<template>
	<div @click="$emit('click')" class="card-listing">
		<div class="wrapper-img">
			<picture>
				<source type="image/webp" :srcset="card.imagemin">
				<img :src="card.image"  alt="product image">
			</picture>
		</div>
		<div class="container-content">
			<div>
				<h3>{{ card.title }}</h3>
				<p class="description">{{ card.subtitle }}</p>
			</div>
			<div v-if="card.chips && card.chips.length" class="product-chips">
				<span class="chip" v-for="(chip, i) in card.chips" :key="i">
					<img :src="chip.icon" alt="">{{ chip.label }}
				</span>
			</div>
			<div class="price-container">
				<p class="price-strike" v-if="shopStore.currencyItemPrice(card, true)">{{ currencyStore.readableCurrencyValue(shopStore.currencyItemPrice(card, true), false) }}</p>
				<p class="price">{{ currencyStore.readableCurrencyValue(shopStore.currencyItemPrice(card), false) }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import {useShopStore} from "@/shop/stores";
export default {
	setup() {
		const languageStore = useLanguageStore();
		const shopStore = useShopStore();
		const currencyStore = useCurrencyStore();
		return {languageStore, currencyStore, shopStore, getString: languageStore.getString};
	},
	emits: [
		'click'
	],
	name: "CardListing",
	props: {
		card: {
			type: Object,
			required: true,
			validator(value) { return value && value.id && value.title && value.subtitle && value.imagemin && value.image; },
		},
	},
}
</script>

<style lang="scss" scoped>
.card-listing {
	display: flex;
	flex-direction: column;
	background-color: var(--color-bg);
	box-shadow: 0 3px 5px var(--color-box-shadow-3);
	border-radius: 13px;
	padding: 18px;
	width: 295px;
	cursor: pointer;
	transition: all .3s $transition;
	@media(max-width: 330px) {
		width: 100%;
	}
	.wrapper-img {
		border-radius: 11px;
		overflow: hidden;
		position: relative;
		width: 258px;
		height: 258px;
		@media(max-width: 330px) {
			width: 100%;
		}
		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 11px;
			z-index: 1;
			box-shadow: inset 1px 2px 3px var(--color-box-shadow-3);
		}
		img {
			object-fit: contain;
			width: 100%;
			height: 100%;
			transition: all .3s $transition;
			@media(max-width: 330px) {
				object-fit: cover;
			}
		}
	}
	.container-content {
		margin-top: 18px;
		display: flex;
		flex-direction: column;
		flex: 1;
		justify-content: space-between;
		h3 {
			text-align: left;
			font: normal normal bold 16px/19px Montserrat;
			color: var(--color-txt);
		}
		.description {
			margin-top: 5px;
			text-align: left;
			font: normal normal medium 10px/13px Montserrat;
			color: var(--color-txt-1);
			@include truncateString(2);
		}
		.product-chips {
			display: flex;
			gap: 6px;
			flex-wrap: wrap;
			margin-top: 10px;
			.chip {
				display: inline-flex;
				align-items: center;
				gap: 4px;
				padding: 2px 7px;
				border: 1px solid var(--color-secondary);
				border-radius: 20px;
				font-size: 10px;
				font-weight: 500;
				color: var(--color-txt-1);
				background: #2debbf1a;
				img {
					width: 12px;
					height: 12px;
				}
			}
		}
		.price-container {
			margin-top: 15px;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			.price-strike {
				font: normal 13px/16px Montserrat;
				color: var(--color-txt-2);
				position: relative;
				&:after {
					content: "";
					position: absolute;
					top: 50%;
					left: 0;
					width: 100%;
					height: 1.5px;
					background-color: var(--color-txt-2);
				}
			}
		}
		.price {
			margin-top: 0;
			text-align: right;
			font: normal normal bold 16px/19px Montserrat;
			color: var(--color-txt);
		}
	}
	&:hover {
		box-shadow: 0 3px 30px -5px var(--color-box-shadow-3);
		.wrapper-img {
			img {
				transform: scale(1.05);
			}
		}
	}
	&:active {
		animation: gelatine 0.3s forwards;
		@keyframes gelatine {
			from, to { transform: scale(1, 1); }
			25% { transform: scale(0.98, 1.02); }
			50% { transform: scale(1.02, 0.98); }
			75% { transform: scale(0.99, 1.01 ); }
		}
	}
}
</style>